import { render } from "./DevamRapor.vue?vue&type=template&id=517f6762&scoped=true"
import script from "./DevamRapor.vue?vue&type=script&lang=js"
export * from "./DevamRapor.vue?vue&type=script&lang=js"

import "./DevamRapor.vue?vue&type=style&index=0&id=517f6762&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517f6762"]])

export default __exports__